import { baseApiEndpoint } from 'config';
import { formatDisplayDate } from 'lib/moment/utils';
import { MAX_UNREAD_BADGE } from './constants';

/** Ảnh avatar người gửi / banner — GET /images/{id} (SPEC mục 5.8) */
export const getNotificationImageUrl = (imageId?: string | null) =>
  imageId ? `${baseApiEndpoint}/images/${imageId}` : undefined;

/**
 * Định dạng thời gian rõ ràng ngày + giờ — SPEC mục 2.1
 * VD: "Thứ tư, 19 tháng 7, 2026 lúc 17:08"
 * Viết hoa chữ cái đầu (locale `vi` của dayjs trả `dddd` chữ thường).
 */
export const formatNotificationDateTime = (date?: string) => {
  const formatted = formatDisplayDate(date, {
    format: 'dddd, D [tháng] M, YYYY [lúc] HH:mm',
  });
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

/** Rút gọn số chưa đọc — SPEC mục 2.1 / 4.2 */
export const formatUnreadBadge = (count?: number) => {
  if (!count || count <= 0) return 0;
  return count > MAX_UNREAD_BADGE ? `${MAX_UNREAD_BADGE}+` : count;
};

/** Ký tự đầu tên người gửi khi không có avatar — SPEC mục 2.1 */
export const getSenderInitial = (senderName?: string | null) =>
  senderName?.trim().charAt(0).toUpperCase() || '?';
